import { HiHeart, HiOutlineHeart } from "react-icons/hi";
import { BannerPink200 } from "ui/assets/svg/tutorial-banners-desktop/BannerPink200";
import { BannerDarkGrey800 } from "ui/assets/svg/tutorial-banners-desktop/BannerDarkGrey800";
import { BannerDarkGrey200 } from "ui/assets/svg/tutorial-banners-desktop/BannerDarkGrey200";
import { BannerPink50 } from "ui/assets/svg/tutorial-banners-desktop/BannerPink50";
import { useWindowWidth } from "ui/utils/hooks";
import { Tutorial, TutorialType } from "domain/entities/tutorials.entities";
import { CardBgPink200 } from "ui/assets/svg/tutorial-card-backgrounds/CardBgPink200";
import { CardBgPink50 } from "ui/assets/svg/tutorial-card-backgrounds/CardBgPink50";
import { CardBgDarkGrey200 } from "ui/assets/svg/tutorial-card-backgrounds/CardBgDarkGrey200";
import { CardBgDarkGrey800 } from "ui/assets/svg/tutorial-card-backgrounds/CardBgDarkGrey800";
import { CustomTextTooltip } from "ui/pages/app/components/CustomTextTooltip";
import { translate } from "ui/i18n";

export function TutorialBanner({
  tutorial,
  isFavorite,
  handleFavoriteClick,
}: {
  tutorial: Tutorial;
  isFavorite?: boolean;
  handleFavoriteClick?: (e: any) => Promise<void>;
}) {
  const isDesktop = useWindowWidth();

  const bannerInfos = getBannerImage(
    tutorial.series as TutorialType,
    isDesktop
  );
  return (
    <div className="activity-banner relative w-full">
      <bannerInfos.image width="100%" height="100%" />
      {isDesktop && (
        <div className="absolute right-6 top-6 hidden space-x-4 md:flex">
          {handleFavoriteClick && typeof isFavorite === "boolean" && (
            <CustomTextTooltip
              text={translate(
                `ns1:Activities.Tooltips.${
                  isFavorite ? "RemoveFromFavorites" : "AddToFavorites"
                }`
              )}
            >
              <button
                className="flex h-10 w-10 items-center justify-center rounded-xl bg-white"
                onClick={handleFavoriteClick}
              >
                {isFavorite ? (
                  <HiHeart className="text-secondaryGrey-900" size={20} />
                ) : (
                  <HiOutlineHeart
                    className="text-secondaryGrey-900"
                    size={20}
                  />
                )}
              </button>
            </CustomTextTooltip>
          )}
        </div>
      )}
      <div
        className={`items-bottom absolute bottom-6 flex w-full space-x-6 px-6 text-2xl ${bannerInfos.color}`}
      >
        <span className="font-bold">{tutorial.title}</span>
      </div>
    </div>
  );
}

export function getBannerImage(activityType: TutorialType, isDesktop: boolean) {
  switch (activityType) {
    case "NUM":
      return {
        image: isDesktop ? BannerPink50 : CardBgPink50,
        color: "text-secondaryGrey-900",
      };
    case "TECH":
      return {
        image: isDesktop ? BannerDarkGrey800 : CardBgDarkGrey800,
        color: "text-white",
      };
    case "SKILLS":
      return {
        image: isDesktop ? BannerDarkGrey200 : CardBgDarkGrey200,
        color: "text-secondaryGrey-900",
      };
    case "FOND":
      return {
        image: isDesktop ? BannerPink200 : CardBgPink200,
        color: "text-secondaryGrey-900",
      };
    default:
      return {
        image: isDesktop ? BannerPink200 : CardBgPink200,
        color: "text-secondaryGrey-900",
      };
  }
}
